import { render } from "./HomeView.vue?vue&type=template&id=980ac3be"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"
script.render = render

export default script